module.exports = __webpack_public_path__ + "static/media/cv.b9959e6b.png";